export enum FileDisplayType {
  ICON = 'icon',
  THUMBNAIL = 'thumbnail',
}

export enum FileDisplaySize {
  XSMALL = 'xsmall',
  SMALL = 'small',
  MID = 'mid',
}

export enum FileDisplayIconType {
  GENERIC = 'generic',
  SPECIFIC = 'specific',
}
